export const WeaviateCollectionName = {
  Page: 'PageDocument',
  Faq: 'FaqDocument',
  Pdf: 'MediaFileDocument',
};

/**
 * Includes pre-defined (strapi) site search options and additional, custom options.
 */
export enum SearchCategory {
  Produkte = 'produkte',
  Ratgeber = 'ratgeber',
  Jobs = 'jobs',
  Documents = 'pdf',
  FilialFinder = 'fifi',
  Faq = 'faq',
  OtherPages = 'other',
  Suggestions = 'suggestions',
}

export enum SearchParam {
  query = 'query',
  offset = 'offset',
  limit = 'limit',
  category = 'siteSearchCategory',
}

export const DEFAULT_QUERY_LIMIT_QUERY_SUGGESTIONS = 10;
